<template>
  <div class="page-content-wrapper" v-check-permission="'edit-delivery-of-ambos'">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="card m-b-20">
            <div class="card-block">
              <h4 class="mt-0 header-title">Entrega de ambos</h4>

              <template v-if="item">

                <div class="form-group  mb-3" v-bind:class="{ 'has-danger': $v.item.deliveredToUser.$error }">
                  <label>Alumno</label>
                  <div class="col-md-8" style="padding-left: 0;">
                    <v-select id="user" :options="students" :value="item.deliveredToUser" v-model="item.deliveredToUser">
                      <span slot="no-options">No se han encontrado resultados.</span>
                    </v-select>
                  </div>
                  <div class="form-control-feedback" v-if="!$v.item.deliveredToUser.required && $v.item.deliveredToUser.$error">El alumno es requerido.</div>
                </div>

                <div class="form-group mb-3" v-bind:class="{ 'has-danger': $v.item.deliveredProduct.$error }">
                  <label>Prenda/Ambo</label>
                  <div class="col-md-8" style="padding-left: 0;">
                    <v-select id="itemOfStockOfAmbos" :options="ambos" v-model="item.deliveredProduct">
                      <slot name="no-options">No se encontraron resultados.</slot>
                    </v-select>
                  </div>
                  <div class="form-control-feedback" v-if="!$v.item.deliveredProduct.required && $v.item.deliveredProduct.$error">La prenda a entregar es requerida.</div>
                </div>

                <div class="row">
                  <div class="form-group col-md-3 mb-3"  v-bind:class="{ 'has-danger': $v.item.deliveredQuantity.$error }">
                    <label>Cantidad</label>
                    <input type="number" min="0" class="form-control" v-model="item.deliveredQuantity">
                    <div class="form-control-feedback" v-if="!$v.item.deliveredQuantity.required && $v.item.deliveredQuantity.$error">La cantidad es requerida.</div>
                    <div class="form-control-feedback" v-if="!$v.item.deliveredQuantity.minValue && $v.item.deliveredQuantity.$error">El monto mínimo aceptado es 1.</div>
                    <small>Ingresar la cantidad entregada/reservada.</small>
                  </div>

                  <div class="form-group col-md-3 mb-3"  v-bind:class="{ 'has-danger': $v.item.status.$error }">
                    <label>Estado</label>
                    <div style="padding-left: 0;">
                      <select id="deliveredStatus" class="custom-select form-control" v-model="item.status">
                        <option v-for="item in deliveredStatus" v-bind:value="item.key">{{ item.text }}</option>
                      </select>
                    </div>
                    <div class="form-control-feedback" v-if="!$v.item.status.required && $v.item.status.$error">El estado es requerido.</div>
                  </div>
                </div>

                <div class="form-group mb-3">
                  <label>Comentarios</label>
                  <textarea class="form-control col-md-6 " v-model="item.comments"></textarea>
                </div>

                <div class="card-block pull-right pr-0">
                  <router-link to="/list-delivery-of-ambos" class="btn btn-secondary waves-effect m-r-10">Cancelar</router-link>
                  <a href="javascript:void(0);" class="btn btn-primary waves-effect waves-light save-btn" @click="submit()">Guardar</a>
                </div>

              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { required, minValue } from 'vuelidate/lib/validators'
  import sizes from '../data/sizes'
  import vSelect from 'vue-select'

  export default {
    name: 'edit-item-of-delivery-of-ambos',


    components: {
      vSelect
    },


    created () {
      this.getAllItemsOfStockOfAmbos();
      this.getStudentFileList();
    },




    data () {
      return {
        sizes: sizes,
        deliveredStatus: [
          { key: 'delivered', text: 'Entregado'},
          { key: 'reserved', text: 'Reservado'}
        ],
        students : [],
        ambos: [],
        item: {
          deliveredQuantity: 1
        }
      }
    },




    computed: {
      itemsOfStockOfAmbos: function () {
        return this.$store.getters.getAllItemsOfStockOfAmbos
      },

      studentFileList: function () {
        return this.$store.getters.getStudentFileList
      }
    },




    validations: {
      item: {
        deliveredToUser: {
          required
        },
        deliveredProduct: {
          required
        },
        deliveredQuantity: {
          required,
          minValue: minValue(1)
        },
        status: {
          required
        },
      }
    },




    methods: {

      /*getItemOfDeliveryOfAmbos: function () {
        this.$loader.loading();

        this.$store.dispatch('getItemOfDeliveryOfAmbos', { id : this.$route.params.id })
          .then((response) => {
            this.$loader.close();
          })
          .catch(error => {
            this.$message.error({text: error})
          })
      },*/



      getAllItemsOfStockOfAmbos () {
        var self = this;
        this.$loader.loading();

        this.$store.dispatch('getAllItemsOfStockOfAmbos', { params : { limit: 9999 } })
          .then((response) => {
            response.data.docs.forEach(function (item) {
              self.ambos.push({
                label: item.name + ' - ' + item.career.name + ' - Talle ' + item.size + ' - (' + item.amount + ' unidades)',
                value: item._id
              })
            });
            this.$loader.close();
          })
          .catch((response) => {
            this.$loader.close();
            this.$message.error({text: response.message});
          })
      },




      getStudentFileList () {
        var self = this;
        this.$loader.loading();
        this.$store.dispatch('getStudentFileList')
          .then((response) => {

            response.data.forEach(function (item) {
              self.students.push({
                label: item.personalData.dni + ' - ' + item.personalData.lastName + ' ' + item.personalData.firstName + ' - (' + item.registration_to_career.level + 'º en ' + item.current_career + ' - Ciclo ' + item.registration_to_career.academicYear + ')',
                value: item.user
              })
            });

            this.$loader.close();
          })
          .catch((response) => {
            this.$loader.close();
            this.$message.error({text: response.message});
          })
      },




      submit: function () {
        const self = this
        this.$v.item.$touch()

        if(!self.$v.item.$error) {
          $('.save-btn').attr('disabled', true);

          this.$store.dispatch('editItemOfDeliveryOfAmbos', {item: self.item})
            .then((response) => {

              if(response.success) {
                self.$message.success({text: response.message});

                setTimeout(function () {
                  self.$router.push('/list-delivery-of-ambos')
                }, 500)
              } else {
                self.$message.error({text: response.message});
              }

              $('.save-btn').attr('disabled', false)
            })
            .catch((response) => {
              self.$message.error({text: response.message});
              $('.save-btn').attr('disabled', false)
            })
        }
      }

    }
  }
</script>

<style scoped>

  .v-select .dropdown-toggle::after {
    content: normal;
  }

</style>



// WEBPACK FOOTER //
// src/screens/EditItemOfDeliveryOfAmbosScreen.vue